<template>
  <div>
    <Header
      :bannerData="bannerData"
    />
    <div class="container pt-4 pb-4 body">
      <div class="columns is-centered">
        <div class="column is-12-tablet is-12-desktop is-10-fullhd">
          <router-view @bannerData="onBannerData" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Layout/Header'

export default {
  name: 'HomeContainer',
  components: {
    Header
  },
  data () {
    return {
      bannerData: '',
      currentComponent: ''
    }
  },
  computed: {
    text () {
      return this.$root.globalText[this.$root.language].menu
    },
    version () {
      return `Auris v${this.$root.version}`
    },
    session () {
      return this.$session.get()
    }
  },
  created () {
    this.currentComponent = 'Home'
  },
  methods: {
    onBannerData (event) {
      this.bannerData = event
    }
  }
}
</script>
